export default {
  "content": "<g clip-path=\"url(#icon_nav_payment_issue_svg__a)\"><path d=\"M7 15c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm7.5 0c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1z\"/><path fill-rule=\"evenodd\" d=\"M.5 0C.22 0 0 .22 0 .5s.22.5.5.5h2.58l1.93 11.58c.04.24.25.42.49.42H14c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H5.92l-.33-2h8.91c.24 0 .45-.17.49-.41l1-5.5c.03-.15-.01-.3-.11-.41a.51.51 0 00-.38-.18h-11L3.99.42A.503.503 0 003.5 0h-3zm4.17 4.5L5.42 9h8.67l.82-4.5H4.67z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"icon_nav_payment_issue_svg__a\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};